// Cross-document view transitions into the portal (docs/KB.md gotcha 24). A transition keeps
// the element that carries a view-transition-name (the header: `es-header`) as its live "new"
// image; REMOVING or REPLACING that element while the transition runs makes Chrome abort it —
// the cross-fade snaps to its end. The portal's first frame is App's boot band (a
// `.es-header`), which React replaces once /api/me lands (splash → page → real header), and
// /api/me can land inside the ~180 ms fade. So App waits for a running transition to finish
// before that first swap. Resolves at once when none is running (a cold load, a prerendered
// page — its fade happens at activation, over DOM that no longer changes — or a browser
// without cross-document transitions); never holds longer than `cap`.
export function afterViewTransition(cap = 400) {
  let running = [];
  try {
    running = document.getAnimations().filter((a) => String(a.effect?.pseudoElement || '').startsWith('::view-transition'));
  } catch { running = []; }
  if (!running.length) return Promise.resolve();
  return Promise.race([
    Promise.all(running.map((a) => a.finished.catch(() => {}))),
    new Promise((resolve) => { setTimeout(resolve, cap); })
  ]).then(() => {});
}
